module.exports = __webpack_public_path__ + "img/02.925b284d.jpg";